<template>
    <div class="column is-2-mobile is-1-tablet hide-mobile">
        <div
            v-if="getBankStatus !== 'classic'"
            class="bankstatus-header__icon has-pointer"
            @click="openBankstatusOverlay"
            :class="computedClass"
        >
            <app-icon custom-class="icon" :icon="`${getBankStatus}-trophy`" size-px="32px" />
        </div>
    </div>
</template>

<script>
import AppIcon from '@/components/AppIcon';
import EventBus from '@/eventBus.js';

export default {
    name: 'BankStatusIcon',
    components: { AppIcon },
    data() {
        return {
            animate: false,
        };
    },
    computed: {
        getBankStatus() {
            return this.$store.getters.getBankStatus;
        },
        computedClass() {
            return {
                'bankstatus-header__shadow': this.getBankStatus !== 'classic',
                // animate-bounce or animate-pulse
                'animate-pulse': this.animate,
            };
        },
    },
    watch: {
        getBankStatus(a, b) {
            if (a !== b) {
                setTimeout(() => {
                    this.animate = true;
                }, 200);
                this.animate = false;
            }
        },
    },
    methods: {
        openBankstatusOverlay() {
            EventBus.$emit('modal-bankstatus');
        },
    },
};
</script>
